import { useState } from 'react'

// local imports
import { IFilteredMeetingRoomList } from 'types/MeetingRoomType'
import MeetingRoomService from 'service/MeetingRoomService'

export default function useGetMeetingRoomList() {
  const [meetingRooms, setMeetingRooms] = useState<IFilteredMeetingRoomList[] | []>([])
  const [loading, setLoading] = useState(false)

  /* Get Meeting Room List */
  const getMeetingRoomList = (data: any) => {
    setLoading(true)
    MeetingRoomService.getMeetingRoomFilteredList(data)
      .then((r) => setMeetingRooms(r.data))
      .finally(() => setLoading(false))
  }

  return { meetingRooms, getMeetingRoomList, loading }
}
